module.exports = __webpack_public_path__ + "img/ayhf.875c65b9.png";